module.exports = __webpack_public_path__ + "static/img/sistema-gestion.10e4a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/sistema-gestion.png
// module id = xq0D
// module chunks = 0